export default __webpack_public_path__ + "static/media/motor_cortex_mask.31ae8071.png";